<div *ngIf="isLoading" class="loading-container">
    <!-- {{ countValue }} -->
    <i class="fa fa-spinner" aria-hidden="true"></i>
</div>